import { Button, Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { connect, useDispatch, useSelector } from "react-redux";
import { InboxOutlined, FilePdfOutlined, FileWordOutlined, FileOutlined } from "@ant-design/icons";

import { useEffect, useState } from "react";
import { Form as FormAnt, Upload } from "antd";
import { calcularMontoArray, formatNewDate } from "../../../../../utils/utils";

import { gestionService } from "../../../../../_services/gestionLegal.service";
import { getTipoEtapas } from "../../../../../redux/Sections/Estados/actions";

import { API } from "../../../../../axios/API";
import ReactSelect from "react-select";
import Swal from "sweetalert2";
import jsPDF from "jspdf";

import { setLoading } from "../../../../../redux/Loading/actions";
import { useUser } from "../../../../../hooks/useUser";
import LogoSN from "../../../../../assets/static/images/LogoSN.jpg";
import moment from "moment";
import { deudasService } from "../../../../../_services/deudas.service";
import ModalPDF from "../../../../../components/ModalPDF";
import { RecursosComercio } from "../../../../../constants";
import "./NewActuacion.css";

const NewActuacion = ({ data, type, handleClose, rowSelects, tipoActuacion, typeData, abogado, datosCargados }) => {
  const { abogadosList } = useSelector(e => e.dashboard);
  const {
    tipoEtapas,
  } = useSelector(e => e.dashboard);
  const dispatch = useDispatch();
  const user = useUser();

  const [modos, setModos] = useState([]);
  const [files, setFiles] = useState([]);
  const [actuacionType, setActuacionType] = useState({
    name: "",
    select: false,
  });
  const [show, setShow] = useState(false);
  const [values, setValues] = useState(false);

  const {
    register,
    reset,
    setValue,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: data,
  });

  useEffect(() => {
    if (type) {
      dispatch(getTipoEtapas(type));
    }
  }, [type]);

  useEffect(() => {
    const getModos = async () => {
      let response = await API.get("/actuaciones/modos");

      if (response.data?.length) {
        setModos(response.data?.map(e => {
          return {
            ...e,
            label: e.nombre,
            value: e.id
          };
        }));
      }
      else {
        setModos([]);
      }
    };

    try {
      getModos();
    }
    catch (err) {
      console.error(err);
    }
  }, [type]);

  useEffect(() => {
    reset();
    setValue("tp_id", actuacionType.name);
    setValue("fecha", formatNewDate());
  }, [data, actuacionType.name]);

  const handleOpenPDF = (e) => {
    setShow(true);
    setValues(e);
  };

  const handleClosePDF = () => {
    setShow(false);
    handleClose();
  };

  const generatePDF = async (data) => {
    try {
      const contrib = [];
      const deudas = [];

      for (const e of data.imponibles) {
        const res = await gestionService.basexImp({
          imponible: e.imponible || e.NRO_COMERCIO,
          tipo: typeData === "inmuebles" ? "I" : "C"
        });

        if (typeof res !== "string") {
          contrib.push(res[0]);
        }
        else {
          continue;
        }
      }

      for (const e of data.imponibles) {
        const res = await deudasService.getDeuda({
          imponible: e.imponible || e.NRO_COMERCIO,
          recurso: e.recurso
        });

        if (res?.data?.mensaje) {
          continue;
        }
        else {
          deudas.push({
            ...e,
            ...res.data
          });
        }
      }


      let profesional = abogadosList.find((e) => e?.codexterno === abogado);

      const doc = new jsPDF({
        orientation: "p",
        unit: "px",
        format: [595, 842],
      });

      const openHtml = `<!DOCTYPE html>
        <html>        
        <head>
          <meta charset="utf-8" />
          <title>
          </title>
          <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Arial" rel="stylesheet" >
        </head>
        <style>
          body {
            margin: 0;
            padding: 0;
          }        
        </style>        
        <body>`;
      const closeHtml = "</body></html>";


      let bodyhtml = "";
      bodyhtml += `
      <div style="display: flex; width: 595px; padding: 30px; font-size: 12px; line-height: 16px; font-family: serif;">
        <div>  
          <div style="text-align: center;">
            <img src=${LogoSN} height="75px" width="auto">
          </div>
          <div style="text-align: center;">
            <b>MUNICIPALIDAD SAN NICOLÁS</b>
          </div>
          <div style="text-align: center;">
            <b>ÚLTIMA INTIMACION PREJUDICIAL</b>
          </div>
          <br/>
          <div>
            Contribuyente: ${contrib[0]["CONTRIBUYENTE"] || ""}
          </div>
          <div>
            Domicilio: ${contrib[0]["CALLE"] || ""} ${contrib[0]["NRO"] || ""} ${contrib[0]["BARRIO"] || ""} (${contrib[0]["COD_POS"] || ""})
          </div>
          <br/>
          <div style="text-align: end;">
            Fecha de emisión: ${moment().format("DD/MM/YYYY")}
          </div>
          <br/>
          <div>
           <p style="text-indent: 2cm;">Por la presente le hago saber, en calidad de <b><u>Apoderado Fiscal de la Municipalidad de San Nicolás de los Arroyos</u></b>,
            conforme Poder Especial que fuera otorgado dentro del marco de la Ordenanza Nº 8203/12, que conforme nuestros
            registros usted mantiene una deuda con mi mandante, en concepto de las obligaciones fiscales que infra se detallan
            y a saber:</p>
          </div>
          <br/>
          `;

      bodyhtml += "<div>";
      deudas.forEach((e) => {
        if (e.legal?.length) {
          const monto = calcularMontoArray(e.legal, "TOTAL");
          const date = new Date();
          let fecha = new Date(`${date.getFullYear()}/${date.getMonth() + 1}/10`);

          if (fecha.getDay() === 6 || fecha.getDay() === 0) {
            fecha = new Date(`${date.getFullYear()}/${date.getMonth() + 1}/12`);
          }

          return bodyhtml += `<b>Recurso ${e.recurso} Número ${e.imponible || e.NRO_COMERCIO}; Monto $ ${monto} de Deuda vigente al ${moment(fecha).format("DD/MM/YYYY")};</b><br/>`;
        }
      });
      bodyhtml += "</div><br/>";

      bodyhtml += `<div>
          </div>
          <div>
            <p style="text-indent: 2cm;">A tal efecto, informo a Ud. que es mi obligación proceder al cobro extrajudicial de la misma, estando
              autorizado a convenir
              pagos de contado y/o a suscribir planes de facilidades de pago, previa autorización Municipal, como última
              alternativa para el cobro
              de la deuda antes de iniciar las actuaciones judiciales correspondientes.</p>
          </div>
          <br/>
          <div>
            <p style="text-indent: 2cm;">Por lo expuesto, se intima a que dentro de un ULTIMO E IMPRORROGABLE plazo de cinco (5) DÍAS de notificada la
              presente, concurra a mi <b>Estudio Jurídico</b>,
              sito en <b>calle ${profesional?.direccion || ""}</b> de esta Ciudad de San Nicolás, <b>${profesional?.horarios || ""}</b>         
              `;

      if (profesional?.te) {
        bodyhtml += `, o comunicarse telefónicamente al ${profesional.te}`;
      }

      bodyhtml += `, en los mismos días y horarios, a fin de interiorizarse de su situación de deuda con el Municipio y
              poder arribar a una amigable composición de intereses, y evitar el inicio de acciones judiciales y/o la
              continuación de las que ya hubieren sido iniciadas
              con las costas y costos que éstas conllevan y las consecuencias que de las mismas derivan (<b>embargo de sueldos
                y/o bienes registrables, inhibiciones personales, VERAZ, entre otros</b>).</p>
          </div>
          <br/>
          <div>
            <p style="text-indent: 2cm;">Evite circunstancias indeseadas y concurra a regularizar su situación en los plazos indicados. Queda usted
              debidamente notificado/a.</p>
          </div>
        </div>
      </div>
      `;

      const html = openHtml + bodyhtml + closeHtml;

      let pdf = await new Promise((resolve, reject) => {
        try {
          doc.html(html, {
            callback: function (doc) {
              Swal.close();
              const buffer = doc.output("blob");
              return resolve(buffer);
            },
          });
        }
        catch (err) {
          return reject(err);
        }
      });

      return pdf;
    }
    catch (err) {
      console.log(err);
    }
  };

  const onSubmit = async (data) => {
    try {
      dispatch(setLoading(true));
      data.abogado = user?.abogado;
      data.files = files;
      data.actuacion = type;
      data.gp_id = type;
      data.imponibles = rowSelects;

      if (typeData === "comercios") {
        data.imponibles = rowSelects.map((e) => {
          return data.recursos.map(recurso => {
            return {
              imponible: e.NRO_COMERCIO,
              recurso,
              APYNOM: e.APYNOM
            };
          });
        }).flat();
      }
      if (data.monto) {
        data.monto = data.monto.replace(",", ".");
      }
      if (data.valor) {
        data.valor = data.valor.replace(",", ".");
      }

      data.cp8480 = data.cp8480 ? 1 : 0;
      data.cpantprv = data.cpantprv ? 1 : 0;

      data.proceso = "A";
      data.id_etapa = 0;

      if (data.tp_id === "10") {
        data.pdf = await generatePDF(data);
      }

      let response = await gestionService.createActuacion(data);

      if (typeof response.result[0] === "string") {
        dispatch(setLoading(false));
        Swal.fire("Error!", "Ocurrio un error, intentelo nuevamente.", "error");
      }
      else {
        // reloadData();
        dispatch(setLoading(false));

        Swal.fire({
          title: "Exito!",
          text: "Las actuaciones se grabarón correctamente.",
          icon: "success",
          willClose: () => {
            if (data.tp_id === "10") {
              return handleOpenPDF(response);
            } else {
              return handleClose();
            }
          }
        });
      }
    }
    catch (err) {
      dispatch(setLoading(false));
      Swal.fire("Error!", "Ocurrio un error, intentelo nuevamente.", "error");
    }
  };

  const normFile = (e) => {
    setFiles(e.fileList);
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  const handleChange = (e) => {
    if (!e.target.value) {
      return setActuacionType({
        name: "",
        select: false,
      });
    }

    setActuacionType({
      name: e.target.value,
      select: true,
    });
  };

  if (type === 2) {
    return (
      <Form className="actuaciones-form" onSubmit={handleSubmit(onSubmit)}>
        <h5 className="ml-3 mb-4">{tipoActuacion?.nombre}</h5>
        {typeData === "comercios" && (
          <Row>
            <Col md={4} className="d-flex">
              <Form.Label className="actuacion-label">Recurso</Form.Label>
            </Col>
            <Col>
              {RecursosComercio.map((e) => {
                return (
                  <div key={e.value} className="com-recurso d-flex align-items-center my-2">
                    <Form.Check
                      name="recursos"
                      id={e.value}
                      value={e.value}
                      className={`${errors.recursos ? "check-invalid" : ""}`}
                      style={{ width: 20, height: 20 }}
                      {...register("recursos", { required: "Este campo es obligatoria" })}
                    />
                    <label htmlFor={e.value}>{e.description}</label>
                  </div>
                );
              })}
              {errors.recursos ? (
                <div
                  className="invalid"
                  style={{
                    fontSize: "80%",
                    color: "#dc3545",
                    marginTop: 4
                  }}
                >
                  {errors.recursos.message}
                </div>
              ) : ""}
            </Col>
          </Row>
        )}
        <Row>
          <Col md={4} className="d-flex">
            <Form.Label className="actuacion-label">Fecha</Form.Label>
          </Col>
          <Col>
            <Form.Control
              name="fecha"
              type="date"
              className={`${errors.fecha ? "is-invalid" : ""}`}
              {...register("fecha", { required: "La fecha es obligatoria" })}
            />
            <Form.Control.Feedback type="invalid">{errors.fecha?.message}</Form.Control.Feedback>
          </Col>
        </Row>
        <Row>
          <Col md={4} className="d-flex">
            <Form.Label className="actuacion-label">Tipo Actuación</Form.Label>
          </Col>
          <Col>
            <Form.Control
              name="tp_id"
              as="select"
              className={`${errors.tp_id ? "is-invalid" : ""}`}
              {...register("tp_id", { required: "El tipo de etapa es obligatorio" })}
            >
              <option value="">Seleccioné un tipo</option>
              {tipoEtapas?.length ? tipoEtapas.map(e => {
                return (
                  <option value={e.tipo} key={e.tipo} >{e.nombre}</option>
                );
              }) : ""}
            </Form.Control>
            <Form.Control.Feedback type="invalid">{errors.tp_id?.message}</Form.Control.Feedback>
          </Col>
        </Row>
        <Row>
          <Col md={4} className="d-flex">
            <Form.Label className="actuacion-label">Observaciones</Form.Label>
          </Col>
          <Col>
            <Form.Control
              name="obs"
              as="textarea"
              rows="6"
              {...register("obs")}
            />
          </Col>
        </Row>

        <div className="mt-5">
          <FormAnt.Item>
            <Form.Label className="mb-2 actuacion-label">Subir archivos:</Form.Label>
            <FormAnt.Item name="dragger" valuePropName="fileList" getValueFromEvent={normFile} noStyle>
              <Upload.Dragger
                multiple
                beforeUpload={() => false}
                name="files"
                listType="picture"
                iconRender={(f) => {
                  if (f.type === "application/pdf") {
                    return <FilePdfOutlined style={{ color: "#FA0F00" }} />;
                  }
                  else if ((f.type === "application/msword") || (f.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document")) {
                    return <FileWordOutlined style={{ color: "#185ABD" }} />;
                  }
                  else {
                    return <FileOutlined />;
                  }
                }}
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">Haga click o arrastre el archivo a esta área para cargarlo</p>
                <p className="ant-upload-hint">Soporte para una carga única o masiva.</p>
              </Upload.Dragger>
            </FormAnt.Item>
          </FormAnt.Item>
        </div>

        {show ? <ModalPDF show={show} handleClose={handleClosePDF} data={values} /> : null}

        <Row className="justify-content-center">
          <Button
            type="submit"
            className="d-flex align-items-center ml-2"
          >
            Grabar Actuación
          </Button>
          <Button
            className="d-flex align-items-center ml-2"
            variant="danger"
            onClick={() => handleClose()}
          >
            Cancelar
          </Button>
        </Row>
      </Form>
    );
  }

  return (
    <Form className="actuaciones-form" onSubmit={handleSubmit(onSubmit)}>
      <h5 className="ml-3 mb-4">{tipoActuacion?.nombre}</h5>
      {typeData === "comercios" && (
        <Row>
          <Col md={4} className="d-flex">
            <Form.Label className="actuacion-label">Recurso</Form.Label>
          </Col>
          <Col>
            {RecursosComercio.map((e) => {
              return (
                <div key={e.value} className="com-recurso d-flex align-items-center my-2">
                  <Form.Check
                    name="recursos"
                    id={e.value}
                    value={e.value}
                    className={`${errors.recursos ? "is-invalid" : ""}`}
                    style={{ width: 20, height: 20 }}
                    {...register("recursos", { required: "Este campo es obligatoria" })}
                  />
                  <label htmlFor={e.value}>{e.description}</label>
                </div>
              );
            })}
            {errors.recursos ? (
              <div
                className="invalid"
                style={{
                  fontSize: "80%",
                  color: "#dc3545",
                  marginTop: 4
                }}
              >
                {errors.recursos.message}
              </div>
            ) : ""}
          </Col>
        </Row>
      )}
      <Row>
        <Col md={4} className="d-flex">
          <Form.Label className="actuacion-label">Tipo Actuación</Form.Label>
        </Col>
        <Col>
          <Form.Control
            name="tp_id"
            className={`${errors.tp_id ? "is-invalid" : ""}`}
            as="select"
            {...register("tp_id", { required: "El tipo de actuación es requerido." })}
            onChange={handleChange}
          >
            <option value="">Seleccioné un tipo</option>
            {tipoEtapas?.length ? tipoEtapas.filter(e => e.show && (e.tipo === 18 || datosCargados)).map(e => {
              return (
                <option value={e.tipo} key={e.tipo}>{e.nombre}</option>
              );
            }) : ""}
          </Form.Control>
          <Form.Control.Feedback type="invalid">{errors.tp_id?.message}</Form.Control.Feedback>
        </Col>
      </Row>
      <Row>
        <Col md={4} className="d-flex">
          <Form.Label className="actuacion-label">
            {
              +actuacionType.name === 1 ? "Fecha de Inicio" :
                +actuacionType.name === 3 ? "Fecha de Presentación" :
                  +actuacionType.name === 4 ? "Fecha de Dictado de Sentencia" :
                    +actuacionType.name === 5 ? "Fecha de Presentación" :
                      "Fecha"
            }
          </Form.Label>
        </Col>
        <Col className={`${actuacionType.select ? "" : "mb-3"}`}>
          <Form.Control
            name="fecha"
            type="date"
            className={`${errors.fecha ? "is-invalid" : ""}`}
            {...register("fecha", { required: "La fecha es requerida." })}
          />
          <Form.Control.Feedback type="invalid">{errors.fecha?.message}</Form.Control.Feedback>
        </Col>
      </Row>

      {actuacionType.select ?
        <>
          {+actuacionType.name === 18 ?
            <>
              <Row>
                <Col md={4} className="d-flex">
                  <Form.Label className="actuacion-label">Carátula</Form.Label>
                </Col>
                <Col>
                  <Form.Control
                    name="caratula"
                    className={`${errors.caratula ? "is-invalid" : ""}`}

                    {...register("caratula", { required: "La caratula es requerida." })}
                  />
                  <Form.Control.Feedback type="invalid">{errors.caratula?.message}</Form.Control.Feedback>
                </Col>
              </Row>
              <Row>
                <Col md={4} className="d-flex">
                  <Form.Label className="actuacion-label">Nro de Expte</Form.Label>
                </Col>
                <Col>
                  <Form.Control
                    name="nroexpte"
                    className={`${errors.nroexpte ? "is-invalid" : ""}`}

                    {...register("nroexpte", { required: "El número de expediente es requerido." })}
                  />
                  <Form.Control.Feedback type="invalid">{errors.nroexpte?.message}</Form.Control.Feedback>
                </Col>
              </Row>
              <Row>
                <Col md={4} className="d-flex">
                  <Form.Label className="actuacion-label">Nro de Título Ejecutivo</Form.Label>
                </Col>
                <Col>
                  <Form.Control
                    name="nrotit"
                    className={`${errors.nrotit ? "is-invalid" : ""}`}
                    {...register("nrotit", { required: "El número de titulo ejecutivo es requerido." })}
                  />
                  <Form.Control.Feedback type="invalid">{errors.nrotit?.message}</Form.Control.Feedback>
                </Col>
              </Row>
              <Row>
                <Col md={4} className="d-flex">
                  <Form.Label className="actuacion-label">Juzgado que interviene</Form.Label>
                </Col>
                <Col>
                  <Form.Control
                    name="juzgado"
                    className={`${errors.juzgado ? "is-invalid" : ""}`}
                    {...register("juzgado", { required: "El juzgado es requerido." })}
                  />
                  <Form.Control.Feedback type="invalid">{errors.juzgado?.message}</Form.Control.Feedback>
                </Col>
              </Row>
              <Row>
                <Col md={4} className="d-flex">
                  <Form.Label className="actuacion-label">Monto</Form.Label>
                </Col>
                <Col>
                  <Controller
                    control={control}
                    name="monto"
                    render={({ field: { value, onChange } }) => {
                      return (
                        <Form.Control
                          className={`${errors.monto ? "is-invalid" : ""}`}
                          onChange={(e) => {
                            let result = e.target.value.replace(/[^0-9,]/g, "").replace(/(\..*?)\..*/g, "$1");
                            let parts = result.split(",");

                            if ((parts[1] && parts[1].length > 2) || parts.length > 2) {
                              return onChange(value);
                            }
                            else {
                              return onChange(result);
                            }
                          }}
                          value={value ? value : ""}
                        />
                      );
                    }}
                    rules={{ required: "El monto es requerido." }}
                  />
                  <Form.Control.Feedback type="invalid">{errors.monto?.message}</Form.Control.Feedback>
                </Col>
              </Row>
              <Row className="mb-3 mt-3">
                <Col md={4} className="d-flex">
                  <Form.Label className="actuacion-label">Cumplimiento con pago de Bono Ley 8480</Form.Label>
                </Col>
                <Col>
                  <Form.Check
                    name="cp8480"
                    {...register("cp8480")}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={4} className="d-flex">
                  <Form.Label className="actuacion-label">Cumplimiento con pago Anticipo Previsional</Form.Label>
                </Col>
                <Col>
                  <Form.Check
                    name="cpantprv"
                    {...register("cpantprv")}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={4} className="d-flex">
                  <Form.Label className="actuacion-label">Períodos que abarca</Form.Label>
                </Col>
                <Col>
                  <Form.Control
                    name="periodos"
                    className={`${errors.periodos ? "is-invalid" : ""}`}
                    {...register("periodos", { required: "El periodo que abarca es requerido." })}
                  />
                  <Form.Control.Feedback type="invalid">{errors.periodos?.message}</Form.Control.Feedback>
                </Col>
              </Row>
            </>
            : null}


          {+actuacionType.name === 2 ?
            <>
              <Row className="mt-3" >
                <Col md={4} className="d-flex">
                  <Form.Label className="actuacion-label">Resultado</Form.Label>
                </Col>
                <Col>
                  <Form.Check
                    type="radio"
                    label="Positivo"
                    name="resultado"
                    className={`d-flex align-items-end ${errors.resultado ? "is-invalid" : ""}`}
                    value="0"
                    {...register("resultado", { required: "El resultado es requerido." })}
                  />
                </Col>
                <Col>
                  <Form.Check
                    type="radio"
                    label="Negativo"
                    name="resultado"
                    className={`d-flex align-items-end ${errors.resultado ? "is-invalid" : ""}`}
                    value="1"
                    {...register("resultado", { required: "El resultado es requerido." })}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={4}></Col>
                <Col>
                  {errors.resultado ? (
                    <div
                      className="invalid"
                      style={{
                        fontSize: "80%",
                        color: "#dc3545"
                      }}
                    >
                      El resultado es requerido.
                    </div>
                  ) : ""}
                </Col>
              </Row>
            </>
            : null}

          {+actuacionType.name === 3 ?
            <>
              <Row>
                <Col md={4} className="d-flex">
                  <Form.Label className="actuacion-label">Tipo de Medida</Form.Label>
                </Col>
                <Col>
                  <Form.Control
                    name="tipomedida"
                    className={`${errors.tipomedida ? "is-invalid" : ""}`}
                    {...register("tipomedida", { required: "El tipo de medida es requerido." })}
                  />
                  <Form.Control.Feedback type="invalid">{errors.tipomedida?.message}</Form.Control.Feedback>
                </Col>
              </Row>
              <Row>
                <Col md={4} className="d-flex">
                  <Form.Label className="actuacion-label">Resultado de la medida</Form.Label>
                </Col>
                <Col>
                  <Form.Control
                    name="resultado"
                    as="textarea"
                    className={`${errors.resultado ? "is-invalid" : ""}`}
                    rows={4}
                    {...register("resultado", { required: "El resultado es requerido." })}
                  />
                  <Form.Control.Feedback type="invalid">{errors.resultado?.message}</Form.Control.Feedback>
                </Col>
              </Row>
            </>
            : null}

          {+actuacionType.name === 4 ?
            <>
              <Row>
                <Col md={4} className="d-flex">
                  <Form.Label className="actuacion-label">Fecha de Notificación de Sentencia</Form.Label>
                </Col>
                <Col>
                  <Form.Control
                    name="notifsent"
                    type="date"
                    className={`${errors.notifsent ? "is-invalid" : ""}`}
                    {...register("notifsent", { required: "La fecha es requerida." })}
                  />
                  <Form.Control.Feedback type="invalid">{errors.notifsent?.message}</Form.Control.Feedback>

                </Col>
              </Row>
            </>
            : null}

          {+actuacionType.name === 5 ?
            <>
              <Row>
                <Col md={4} className="d-flex">
                  <Form.Label className="actuacion-label">Tipo de Medida Ejecutiva</Form.Label>
                </Col>
                <Col>
                  <Form.Control
                    name="tipomedida"
                    className={`${errors.tipomedida ? "is-invalid" : ""}`}
                    {...register("tipomedida", { required: "El tipo de medida es requerido." })}
                  />
                  <Form.Control.Feedback type="invalid">{errors.tipomedida?.message}</Form.Control.Feedback>
                </Col>
              </Row>
              <Row>
                <Col md={4} className="d-flex">
                  <Form.Label className="actuacion-label">Resultado de la medida</Form.Label>
                </Col>
                <Col>
                  <Form.Control
                    name="resultado"
                    as="textarea"
                    className={`${errors.resultado ? "is-invalid" : ""}`}
                    rows={4}
                    {...register("resultado", { required: "El resultado es requerido." })}
                  />
                  <Form.Control.Feedback type="invalid">{errors.resultado?.message}</Form.Control.Feedback>
                </Col>
              </Row>
            </>
            : null}

          {+actuacionType.name === 6 ?
            <>
              <Row>
                <Col md={4} className="d-flex">
                  <Form.Label className="actuacion-label">Modo</Form.Label>
                </Col>
                <Col>
                  <Controller
                    control={control}
                    name="modo"
                    render={({ field: { onChange } }) => {
                      return (
                        <ReactSelect
                          onChange={(e) => onChange(e?.value)}
                          options={modos}
                        />
                      );
                    }}
                    rules={{ required: "El modo es requerido." }}
                  />
                  <Form.Control.Feedback type="invalid">{errors.modo?.message}</Form.Control.Feedback>
                </Col>
              </Row>
              <Row>
                <Col md={4} className="d-flex">
                  <Form.Label className="actuacion-label">Valor</Form.Label>
                </Col>
                <Col>
                  <Controller
                    control={control}
                    name="valor"
                    render={({ field: { value, onChange } }) => {
                      return (
                        <Form.Control
                          className={`${errors.valor ? "is-invalid" : ""}`}
                          onChange={(e) => {
                            let result = e.target.value.replace(/[^0-9,]/g, "").replace(/(\..*?)\..*/g, "$1");
                            let parts = result.split(",");

                            if ((parts[1] && parts[1].length > 2) || parts.length > 2) {
                              return onChange(value);
                            }
                            else {
                              return onChange(result);
                            }
                          }}
                          value={value}
                        />
                      );
                    }}
                    rules={{ required: "El valor es requerido." }}
                  />
                  <Form.Control.Feedback type="invalid">{errors.valor?.message}</Form.Control.Feedback>
                </Col>
              </Row>
            </>
            : null}

          <Row className="mt-3">
            <Col md={4} className="d-flex">
              <Form.Label className="actuacion-label">Observaciones</Form.Label>
            </Col>
            <Col>
              <Form.Control
                name="obs"
                as="textarea"
                rows="6"
                {...register("obs")}
              />
            </Col>
          </Row>

          <div className="mt-5">
            <FormAnt.Item>
              <Form.Label className="mb-2 actuacion-label">Subir archivos:</Form.Label>
              <FormAnt.Item name="dragger" valuePropName="fileList" getValueFromEvent={normFile} noStyle>
                <Upload.Dragger
                  multiple
                  beforeUpload={() => false}
                  name="files"
                  listType="picture"
                  iconRender={(f) => {
                    if (f.type === "application/pdf") {
                      return <FilePdfOutlined style={{ color: "#FA0F00" }} />;
                    }
                    else if ((f.type === "application/msword") || (f.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document")) {
                      return <FileWordOutlined style={{ color: "#185ABD" }} />;
                    }
                    else {
                      return <FileOutlined />;
                    }
                  }}
                >
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">Haga click o arrastre el archivo a esta área para cargarlo</p>
                  <p className="ant-upload-hint">Soporte para una carga única o masiva.</p>
                </Upload.Dragger>
              </FormAnt.Item>
            </FormAnt.Item>
          </div>
        </>
        : null}

      <Row className="justify-content-center">
        <Button
          type="submit"
          className="d-flex align-items-center ml-2"
        >
          Grabar Actuación
        </Button>
        <Button
          className="d-flex align-items-center ml-2"
          variant="danger"
          onClick={() => handleClose()}
        >
          Cancelar
        </Button>
      </Row>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.dashboard.data
  };
};

export default connect(mapStateToProps, null)(NewActuacion);